// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import moment from 'moment';

export const getDefaultState = () =>
    new DateRange({
        from: null,
        max: moment
            .utc()
            .add(10, 'year')
            .endOf('day')
            .valueOf(),
        min: moment
            .utc()
            .subtract(10, 'year')
            .startOf('day')
            .valueOf(),
        to: null
    });



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/state/date-range.js